import React from 'react';
import { Sparkles } from 'lucide-react';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { cn } from '@/lib/utils';
import type { SitrepSectionType } from 'components/DisasterGPT/hooks/useSitrepsV2';

type SitrepSectionTabsProps = {
  sections: SitrepSectionType[];
  activeSectionIndex: number | null;
  onSectionChange: (index: number) => void;
  className?: string;
  idBase?: string;
};

const SitrepSectionTabs: React.FC<SitrepSectionTabsProps> = ({
  sections,
  activeSectionIndex,
  onSectionChange,
  className,
  idBase,
}) => {
  if (sections.length === 0) return null;

  const selectedIndex = activeSectionIndex ?? 0;

  return (
    <Tabs
      value={String(selectedIndex)}
      onValueChange={(value) => onSectionChange(Number(value))}
      className={cn('tw:min-w-0', className)}
      data-tour="reports-sections"
    >
      <TabsList
        className="tw:!h-9 tw:!w-full tw:max-w-full tw:!flex-nowrap tw:justify-start tw:overflow-x-auto"
        aria-label="SITREP sections"
      >
        {sections.map((section, index) => (
          <TabsTrigger
            key={section.id}
            value={String(index)}
            id={idBase ? `${idBase}-tab-${index}` : undefined}
            aria-controls={idBase ? `${idBase}-panel-${index}` : undefined}
            className="tw:!w-auto tw:!flex-none tw:!shrink-0"
          >
            {section.name}
            {section.type === 'ai' ? (
              <Sparkles className="tw:size-3" aria-hidden="true" />
            ) : null}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};

export default SitrepSectionTabs;
